"use strict";

define('model/document.letter',['./base', './letter.template', './document', './document.decision'], function (Model, LetterTemplate, Document, DocumentDecision) {
  var DocumentLetter = Model.extend({
    urlRoot: '/rs/api/documentLetter',
    defaults: {
      bcc: '',
      cc: '',
      content: '',
      recipients: '',
      subject: ''
    },
    childModels: {
      'letterTemplate': LetterTemplate,
      'document': Document,
      'decision': DocumentDecision
    },
    virtual: {
      'documentId': Model.createKeyPathVirtual('document.id')
    },
    validation: {
      recipients: {
        required: true
      },
      subject: {
        required: true
      },
      letterTemplate: {
        required: true
      },
      content: {
        required: true
      }
    },
    replaceText: function replaceText(documentId) {
      var _this$get;
      var content = this.get('content');
      if (this !== null && this !== void 0 && this.get('decision') && !(this !== null && this !== void 0 && (_this$get = this.get('decision')) !== null && _this$get !== void 0 && _this$get.isExpirationDateVisible())) {
        content = content.replace('[DECISION_EXPIRATION_DATE]', '--');
      }
      var params = {
          data: JSON.stringify({
            text: content
          }),
          dataType: 'json',
          contentType: 'application/json',
          type: 'POST'
        },
        model = this;
      if (documentId != null) {
        this.set('document', {
          id: documentId
        });
      }
      var ret = this.request('/rs/api/letter/replace/:documentId', params);
      ret.promise().then(function (resp) {
        model.trigger('replace:content', this, resp ? resp.data : '');
        return resp;
      });
      return ret;
    }
  }, {
    allByDocumentId: function allByDocumentId(docId) {
      return this.createCollection('/rs/api/documentLetter/document/:documentId').params({
        documentId: docId
      });
    },
    allByDecisionId: function allByDecisionId(decisionId) {
      return this.createCollection('/rs/api/documentLetter/decision/:decisionId').params({
        decisionId: decisionId
      });
    },
    createPDF: function createPDF() {}
  });
  return DocumentLetter;
});

